import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import CallingPointsService from '../services/CallingPointsService';
import CallingPointsStore from '../stores/CallingPointsStore';

const CallingPointsActions = {

    async getFromService (service) {
        const cached = CallingPointsStore.get(service);

        if (cached) {
            return cached;
        }

        const { callingPoints } = service.journey;
        AppDispatcher.dispatch({
            actionType: ActionTypes.CALLING_POINTS_LOAD_STARTED,
            key: callingPoints
        });
        try {
            const result = await CallingPointsService.get(callingPoints);
            AppDispatcher.dispatch({
                actionType: ActionTypes.CALLING_POINTS_LOADED,
                key: callingPoints,
                callingPoints: result
            });
            return result;

        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.CALLING_POINTS_LOAD_FAILED,
                key: callingPoints
            });
            throw error;
        }

    }

};

export default CallingPointsActions;



// WEBPACK FOOTER //
// ./src/actions/CallingPointsActions.js